import React, { useEffect, useState, useRef } from 'react';
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import CreatableSelect from 'react-select/creatable';
import SearchableDropdown from './DropDown';


import usePermission from "../../config/permissions";
import { Select } from 'antd';
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    CrossRed,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil,
    Active,
    SearchBig,
    Filter
} from "../AllSvg";
import { formatDate } from "../Date";
import Loader from '../Loader';


import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast, formatRoundoff2D, CSSForSelect } from "../custom";
import { get } from 'react-scroll/modules/mixins/scroller';


const PnLSheet = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const employee = sessionStorage.getItem("employee_id")
    const [toggleStatus, setToggleStatus] = useState("pending");
    const [timeSheetData, setTimeSheetData] = useState([]);
    const role = sessionStorage.getItem("role");

    const getTimesheet = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            // url = `${BASE_URL}/project/timesheetsbyemployee/${role === "HOD" ? "null" : employee}/`;
            url = `${BASE_URL_PREBID}/project/ProjectPAndLAPIView/`;//ProjectPAndLAPIView

            const sub = await axios.get(url);

            setTimeSheetData([sub.data]);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (employee != "") {
            getTimesheet();
        }

    }, [toggleStatus, employee]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];


    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content?.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    return (
        <>
            <Dashboardnavbarcopy name="Profit & Loss Sheet" url="P&L Sheet" />

            <div className="content-tabs">
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        {/* <div className="repo-heading font-weight500 font-size-heading">
                            Profit & Loss Sheet Table
                        </div>
                        <div className="field-cont">
                            <div className="table-searchh dropdown-container field-cont-div">
                                <select
                                    onChange={(e) => setToggleStatus(e.target.value)}
                                    value={toggleStatus}
                                    className="dropdown-timesheet font-size-subheading  "
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>
                        </div> */}
                    </div>
                    {/* <SectorsDetailForm /> */}
                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    {/* <th className="table-heading">Sr. No.</th> */}
                                    {/* <th className="table-heading">Client Name</th>
                                    <th className="table-heading">Project</th> */}
                                    <th className="table-heading text-center">Project</th>
                                    <th className="table-heading text-center">Invoice Details</th>
                                    <th className="table-heading">Ticket Bookings</th>
                                    <th className="table-heading">Miscellaneous</th>
                                    <th className="table-heading">Payment Receipts</th>
                                    {/* <th className="table-heading text-center">Employee Salaries</th> */}
                                    <th className="table-heading text-center">Imprest</th>
                                    <th className="table-heading text-center">Expense</th>
                                    <th className="table-heading text-center">Profit or Loss</th>
                                    <th className="table-heading text-center">Profit or Loss Precentage</th>
                                </tr>

                            </thead>

                            {buffer ? (
                                <div className="spinner"></div>
                            ) : (
                                <tbody>
                                    {timeSheetData.map((project, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="12"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                {/* <td className="table-body">{index + 1}</td> */}
                                                {/* <td className="table-body">{project.client_name || "-"}</td>
                                                <td className="table-body">{project.project_short_name || "-"}</td> */}
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}> Without GST Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.project_details?.reduce((sum, item) => sum + parseFloat(item.without_gst_amount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}> GST Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.project_details?.reduce((sum, item) => sum + parseFloat(item.gst_amount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                            <tr >
                                                                <td colSpan={4} className="align-center">
                                                                    <hr className="line" />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Total WO Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.project_details?.reduce((sum, item) => sum + parseFloat(item.woamount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Without GST Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.invoices?.reduce((sum, item) => sum + parseFloat(item.wihoutgst_amount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>GST Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.invoices?.reduce((sum, item) => sum + parseFloat(item.gst_amount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Bill Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.invoices?.reduce((sum, item) => sum + parseFloat(item.billamount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Total Amount Received</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.invoices?.reduce((sum, item) => sum + parseFloat(item.amount_recived || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body text-center">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Total Tickets Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.ticket_bookings?.reduce((sum, item) => sum + parseFloat(item.ticket_amount || 0), 0)) || "-"}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body text-center">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Miscellaneous Expenses</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.miscellaneous_expenses?.reduce((sum, item) => sum + parseFloat(item.expense || 0), 0)) || "-"}                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body text-center">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Reciept Amount</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(project.payment_receipts?.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)) || "-"}                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>

                                                {/* Employee Salaries as a Dropdown */}
                                                {/* <td className="table-body-text">
                                                    {project.employee_salaries?.length > 0 ? (
                                                        <div className="employee-card-image">
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <thead>
                                                                    <tr className="">
                                                                        <th className="padding-bottom-5px">Employee</th>
                                                                        <th style={{ padding: "0px 4px" }}>|</th>
                                                                        <th className="padding-bottom-5px">Total Hours</th>
                                                                        <th style={{ padding: "0px 4px" }}>|</th>
                                                                        <th className="padding-bottom-5px">Calculated Salary</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {project.employee_salaries?.map((emp) => (
                                                                        <tr key={emp.id}>
                                                                            <td className="padding-bottom-5px">{emp.emp_code}</td>
                                                                            <th style={{ padding: "0px 4px" }}>|</th>
                                                                            <td className="padding-bottom-5px">{formatRoundoff2D(emp.total_hours)}hrs.</td>
                                                                            <th style={{ padding: "0px 4px" }}>|</th>
                                                                            <td className="padding-bottom-5px">₹{formatCurrencyIndian(emp.calculated_salary)}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="align-center ">
                                                            <p className="text-center">-</p>
                                                        </div>

                                                    )}

                                                </td > */}
                                                <td className="table-body">
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Transportation</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatCurrencyIndian(project.imprests?.reduce((sum, item) => sum + parseFloat(item.approved_transportation || 0), 0)) || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Accomodation</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatCurrencyIndian(project.imprests?.reduce((sum, item) => sum + parseFloat(item.approved_accomodation || 0), 0)) || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Fooding</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatCurrencyIndian(project.imprests?.reduce((sum, item) => sum + parseFloat(item.approved_fooding || 0), 0)) || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Other</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatCurrencyIndian(project.imprests?.reduce((sum, item) => sum + parseFloat(item.approved_other || 0), 0)) || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr >
                                                            <td colSpan={4} className="align-center">
                                                                <hr className="line" />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Total Imprest</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {formatCurrencyIndian(
                                                                    project.imprests?.reduce((sum, item) => {
                                                                        const otherDetailsSum = item.other_details?.reduce((total, other) => {
                                                                            return total + parseFloat(other.approved_other || 0);
                                                                        }, 0) || 0;

                                                                        return sum + otherDetailsSum +
                                                                            parseFloat(item.approved_transportation || 0) +
                                                                            parseFloat(item.approved_accomodation || 0) +
                                                                            parseFloat(item.approved_fooding || 0);
                                                                    }, 0)
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </td>
                                                <td className="table-body">
                                                    <tbody>
                                                        <tr>
                                                            {/* <td className="table-body" style={{ paddingBottom: "5px" }}>Utilized Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td> */}
                                                            <td className="table-body">{formatCurrencyIndian(project.utilized_amount) || "-"}</td>
                                                        </tr>
                                                    </tbody>
                                                </td>
                                                <td className="table-body">
                                                    <tbody>
                                                        <tr>
                                                            {/* <td className="table-body" style={{ paddingBottom: "5px" }}>Profit or Loss</td> */}
                                                            {/* <td style={{ padding: "0px 4px" }}>:</td> */}
                                                            <td className="align-right" style={{ paddingLeft: "90px" }}>{formatCurrencyIndian(project.profit_or_loss) || "-"}</td>
                                                        </tr>
                                                    </tbody>
                                                </td>
                                                <td className="table-body">
                                                    <tbody>
                                                        <tr>
                                                            {/* <td className="table-body" style={{ paddingBottom: "5px" }}>Profit or Loss Percentage</td> */}
                                                            {/* <td style={{ padding: "0px 4px" }}>:</td> */}
                                                            <td className="align-right" style={{ paddingLeft: "90px" }}>{formatCurrencyIndian(project.profit_or_loss_percentage) || "-"}</td>
                                                        </tr>
                                                    </tbody>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            )}
                        </table>

                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

const ProfitAndLossSheet = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const employee = sessionStorage.getItem("employee_id")
    const [toggleStatus, setToggleStatus] = useState("pending");
    const [timeSheetData, setTimeSheetData] = useState([]);
    const role = sessionStorage.getItem("role");
    const [filter, SetFilter] = useState("null");

    const getTimesheet = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            // url = `${BASE_URL}/project/timesheetsbyemployee/${role === "HOD" ? "null" : employee}/`;
            // url = `${BASE_URL_PREBID}/project/ImprestExpenseAPI/Demo1/`;//ProjectPAndLAPIView
            // url = `${BASE_URL_PREBID}/project/profitandloss/Demo1/`;//ProjectPAndLAPIView
            url = `${BASE_URL_PREBID}/project/profitandlossv4/${filter}/`;//ProjectPAndLAPIView

            const sub = await axios.get(url);
            console.log({ ddd: [sub.data] })
            setTimeSheetData([sub.data]);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (employee != "") {
            getTimesheet();
        }

    }, [toggleStatus, employee, filter]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];


    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content?.replace(linkRegex, (url) => {
                return `< a href = "${url}" target = "_blank" rel = "noopener noreferrer" > ${url}</a > `;
            }),
        };
    };

    const itemsPerPage = 100; // Fixed items per page
    const [currentPage, setCurrentPage] = useState(1);
    const [pageData, setPageData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);

    const [pendencys, setPendencys] = useState({});

    // useEffect(() => {
    //     const newTotalPages = Math.ceil(timeSheetData / itemsPerPage);
    //     setTotalPages(newTotalPages);
    // }, [timeSheetData]);

    // useEffect(() => {
    //   const newTotalPages = Math.ceil(filteredData.length / itemsPerPage);
    //   if (currentPage > newTotalPages) {
    //     setCurrentPage(1); // reset if current page becomes invalid
    //   }
    // }, [filteredData]);


    // useEffect(() => {
    //     const newTotalPages = Math.ceil(timeSheetData[0] / itemsPerPage);



    //     // Optional: reset only if filteredData shrinks AND page is now invalid
    //     if (currentPage > newTotalPages && newTotalPages > 0) {
    //         setTotalPages(newTotalPages);
    //     }
    // }, [timeSheetData]);

    const tableRef = useRef(null);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        // Scroll to top of table when page changes
        if (tableRef && tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const renderPaginationButtons = () => {
        const buttons = [];

        // Always show first page
        buttons.push(
            <button
                key="first"
                className={`pagination-button ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(1)}
            >
                1
            </button>
        );


        if (totalPages > 7) {

            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);


            if (currentPage <= 3) {
                // Near start, show 2,3,4
                startPage = 2;
                endPage = 4;
            } else if (currentPage >= totalPages - 2) {
                // Near end, show last 3 pages before the final page
                startPage = totalPages - 3;
                endPage = totalPages - 1;
            }

            // Show ellipsis before middle range if needed
            if (startPage > 2) {
                buttons.push(<span key="ellipsis1" className="pagination-ellipsis">...</span>);
            }

            // Add middle range
            for (let i = startPage; i <= endPage; i++) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }

            // Show ellipsis after middle range if needed
            if (endPage < totalPages - 1) {
                buttons.push(<span key="ellipsis2" className="pagination-ellipsis">...</span>);
            }

            // Always show last page
            buttons.push(
                <button
                    key="last"
                    className={`pagination-button ${currentPage === totalPages ? 'active' : ''}`}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </button>
            );
        } else {
            // Less than 7 pages, show all page buttons
            for (let i = 2; i <= totalPages; i++) {
                buttons.push(
                    <button
                        key={i}
                        className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
        }

        return buttons;
    };

    const [projectList, setProjectList] = useState([]);

    const getFilterProjects = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL_PREBID}/project/filterprproject/false/`);
            const res = await axios.get(`${BASE_URL_PREBID}/project/projectfilterbysubcompany/null/`);
            setProjectList(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {

        }
    };

    const [isEmployeeDetailsVisible, setIsEmployeeDetailsVisible] = useState(false);
    const [isClientDetailsVisible, setIsClientDetailsVisible] = useState(false);

    useEffect(() => {
        getFilterProjects()
    }, [])

    return (
        <>
            <Dashboardnavbarcopy name="Profit & Loss Sheet" url="P&L Sheet" />

            <div className="content-tabs">
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Profit & Loss Sheet
                        </div>
                        <SearchableDropdown projectList={projectList} SetFilter={SetFilter} />

                        {/* <div className="field-cont">
                            <div className="table-searchh-new dropdown-container field-cont-div">
                                <select
                                    onChange={(e) => SetFilter(e.target.value)}
                                    className="dropdown-timesheet font-size-subheading"
                                    style={{ width: '30vw' }}
                                >
                                    <option value="">Select Projsect</option>
                                    {projectList?.sort((a, b) => a.project_short_name?.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.prebid_prcode}>{i.prebid_prcode}-{i.project_short_name}</option>
                                    ))}
                                </select>
                            </div>
                        </div> */}
                        {/* <div className="flex-column form-group-select">
                            <CreatableSelect
                                options={projectList?.map(i => ({
                                    value: i.project_short_name,
                                    label: i.project_short_name
                                }))}
                                value={filter ? { value: filter, label: filter } : null}
                                onChange={(e) => SetFilter(e.target.value)}
                                placeholder="Select Project"
                                formatCreateLabel={(inputValue) => `Filter by new project: ${inputValue}`}
                                isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                    inputValue.trim() !== '' &&
                                    !selectOptions.find(option => option.label.toLowerCase() === inputValue.toLowerCase())
                                }
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '30vw',
                                        height: '50px',
                                        borderRadius: '10px',
                                        border: '1px solid #e3e3e3',
                                        margin: '10px 0px 3px ',
                                        color: '#4a4a4a',
                                        backgroundColor: '#f7f8fa',
                                        padding: '0px 10px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: '10px',
                                        marginTop: '0',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        height: '15px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '10px 15px',
                                        color: state.isSelected ? 'white' : '#707070',
                                        backgroundColor: state.isSelected ? '#2576bc' : 'white',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: '#2576bc',
                                            color: 'white',
                                        },
                                    }),
                                }}
                            />
                        </div> */}





                        {/* <div className="flex-column form-group-select">
                            <CreatableSelect
                                options={allProjectTypes}
                                value={formData.project_type ? { value: formData.project_type, label: formData.project_type } : null}
                                onChange={(option) => handleChange({
                                    target: {
                                        name: 'project_type',
                                        value: option ? option.value : ''
                                    }
                                })}
                                placeholder="Select Project"
                                // className={`form-input form-group-selection ${errors.project_type ? 'error' : formData.project_type ? 'success' : ''}`}
                                formatCreateLabel={(inputValue) => `Create new project type: ${inputValue}`}
                                isValidNewOption={(inputValue, selectValue, selectOptions) =>
                                    inputValue.trim() !== '' &&
                                    !selectOptions.find(option => option.label.toLowerCase() === inputValue.toLowerCase())
                                }
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '34vw',
                                        height: '50px',
                                        borderRadius: '10px',
                                        border: '1px solid #e3e3e3',
                                        margin: '10px 0px 3px ',
                                        color: '#4a4a4a',
                                        backgroundColor: '#f7f8fa',
                                        padding: '0px 10px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: '10px',
                                        marginTop: '0',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        height: '15px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '10px 15px',
                                        color: state.isSelected ? 'white' : '#707070',
                                        backgroundColor: state.isSelected ? '#2576bc' : 'white',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: '#2576bc',
                                            color: 'white',
                                        },
                                    }),
                                }}
                            />

                        </div> */}
                    </div>
                    {/* <SectorsDetailForm /> */}
                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading">Sr. No.</th>
                                    <th className="table-heading">Project Details</th>
                                    <th className="table-heading">Financial Details</th>
                                    <th className="table-heading">Expense</th>
                                    <th className="table-heading">Profit & Loss</th>
                                </tr>
                            </thead>
                            <tbody>


                                {/* Second set of projects (with data) */}

                                {timeSheetData[0]?.map((project, index) => (
                                    <React.Fragment key={`data-${index}`}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="12"></td>
                                        </tr>
                                        <tr className="custom-table-head-td">
                                            <td className="table-body" style={{ paddingLeft: '35px' }}>{index + 1}</td>
                                            <td className="table-body">
                                                <table style={{ borderCollapse: "collapse", width: '70%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Code</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">{project?.project_details?.project_code || "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Project Name</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">{project?.project_details?.project_short_name || "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Client Count</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">{project?.client_data?.length || "-"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Employee Count</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">{project?.employee_data?.length || "-"}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            {/* Financial Details */}
                                            <td className="table-body">
                                                <table style={{ borderCollapse: "collapse", width: "70%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Basic Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(
                                                                    parseFloat(
                                                                        project?.client_data?.reduce((sum, item) => {
                                                                            return sum + parseFloat(item.without_gst_amount);
                                                                        }, 0)
                                                                    ).toFixed(0)
                                                                ).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>GST Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(parseFloat(project?.client_data?.reduce((sum, item) => {
                                                                    return sum + parseFloat(item.gst_amount);
                                                                }, 0)).toFixed(0)).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Total Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(
                                                                    (
                                                                        (project?.client_data?.reduce((sum, item) => {
                                                                            return sum + parseFloat(item.woamount || 0);
                                                                        }, 0))
                                                                    ).toFixed(0)
                                                                ).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Billed Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(
                                                                    (
                                                                        (project?.client_data?.reduce((sum, item) => {
                                                                            return sum + parseFloat(item.total_billed || 0);
                                                                        }, 0))
                                                                    ).toFixed(0)
                                                                ).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Billed GST Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(
                                                                    (
                                                                        (project?.client_data?.reduce((sum, item) => {
                                                                            return sum + parseFloat(item.total_gst || 0);
                                                                        }, 0))
                                                                    ).toFixed(0)
                                                                ).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Billed Recived Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right`}>
                                                                {Number(
                                                                    (
                                                                        (project?.client_data?.reduce((sum, item) => {
                                                                            return sum + parseFloat(item.total_received || 0);
                                                                        }, 0))
                                                                    ).toFixed(0)
                                                                ).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            {/* Expense */}
                                            <td className="table-body">
                                                <table style={{ borderCollapse: "collapse", width: "70%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Tickets Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {project.ticket_bookings?.reduce((sum, item) => sum + parseFloat(item.ticket_amount || 0), 0).toLocaleString() || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Miscellaneous</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {project.miscellaneous_expenses?.reduce((sum, item) => sum + parseFloat(item.expense || 0), 0).toLocaleString() || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Employee Salary</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {project.total_salary_paid.toFixed(0)?.toLocaleString() || "-"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Imprest Amount</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {project.imprests?.reduce((sum, item) => {
                                                                    return (
                                                                        sum +
                                                                        (Number(item.transportation) || 0) +
                                                                        (Number(item.accomodation) || 0) +
                                                                        (Number(item.fooding) || 0) +
                                                                        (Number(item.other) || 0)
                                                                    );
                                                                }, 0).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>Total</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className="align-right">
                                                                {(
                                                                    Number(
                                                                        (
                                                                            (project.imprests?.reduce((sum, item) => {
                                                                                return (
                                                                                    sum +
                                                                                    (Number(item.transportation) || 0) +
                                                                                    (Number(item.accomodation) || 0) +
                                                                                    (Number(item.fooding) || 0) +
                                                                                    (Number(item.other) || 0)
                                                                                );
                                                                            }, 0) || 0) +

                                                                            (Number(project.total_salary_paid) || 0) +

                                                                            (project.miscellaneous_expenses?.reduce(
                                                                                (sum, item) => sum + parseFloat(item.expense || 0),
                                                                                0
                                                                            ) || 0) +

                                                                            (project.ticket_bookings?.reduce(
                                                                                (sum, item) => sum + parseFloat(item.ticket_amount || 0),
                                                                                0
                                                                            ) || 0)
                                                                        ).toFixed(0)
                                                                    ).toLocaleString() || '-'
                                                                )
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            {/* Profit & Loss */}
                                            <td className="table-body">
                                                <table style={{ borderCollapse: "collapse", width: "70%" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>{project?.profit_or_loss < 0 ? 'Loss' : 'Profit'}</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right ${project?.profit_or_loss < 0 ? 'red-text' : 'green-text'}`}>
                                                                {Number((project?.profit_or_loss || 0).toFixed(0)).toLocaleString()}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="table-body" style={{ paddingBottom: "5px" }}>{project?.profit_or_loss_percentage < 0 ? 'Loss %' : 'Profit %'}</td>
                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                            <td className={`align-right ${project?.profit_or_loss_percentage < 0 ? 'red-text' : 'green-text'}`}>
                                                                {Number((project?.profit_or_loss_percentage || 0).toFixed(0)).toLocaleString()
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                        </tr>

                                        <tr>
                                            <td colSpan="12">
                                                <div style={{ display: 'flex' }}>
                                                    <label className='repo-heading font-weight500 font-size-heading'>Employee Details</label>
                                                    <label onClick={() => setIsEmployeeDetailsVisible(!isEmployeeDetailsVisible)} style={{ marginLeft: 'auto', fontWeight: 600, color: '#2576bc', cursor: 'pointer', fontSize: '14px' }}>{isEmployeeDetailsVisible ? 'Collapse' : 'Expand'}</label>
                                                </div>
                                            </td>
                                        </tr>

                                        {isEmployeeDetailsVisible && (project.employee_data?.map((employee, empIndex) => (
                                            <React.Fragment key={`emp-${empIndex}`}>
                                                {/* Employee Summary */}
                                                <tr className="employee-summary-row">
                                                    <td colSpan="12">
                                                        <label style={{ fontSize: '14px', fontWeight: 500, marginLeft: '15px', marginTop: '15px' }}>Employee {empIndex + 1}</label>
                                                        <div className="employee-summary-container">
                                                            <div className="employee-summary-card">
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Employee Code:</span>
                                                                    <span className="summary-value highlight">{employee.emp_code || "-"}</span>
                                                                </div>
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Total Salary:</span>
                                                                    <span className="summary-value">₹{employee.total_salary.toFixed(0) || "0"}</span>
                                                                </div>
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Attendance Days:</span>
                                                                    <span className="summary-value">{employee.attendance_stats?.total_days || "0"}</span>
                                                                </div>
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Present Days:</span>
                                                                    <span className="summary-value success">{employee.attendance_stats?.present_days || "0"}</span>
                                                                </div>
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Absent Days:</span>
                                                                    <span className="summary-value danger">{employee.attendance_stats?.absent_days || "0"}</span>
                                                                </div>
                                                                <div className="summary-item">
                                                                    <span className="summary-label">Leave Days:</span>
                                                                    <span className="summary-value warning">{employee.attendance_stats?.leave_days || "0"}</span>
                                                                </div>
                                                            </div>

                                                            <div className="employee-summary-card" style={{ overflow: 'hidden', overflowY: 'scroll' }}>
                                                                <div style={{ height: '50px' }}>
                                                                    <table className="attendance-table">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="text-left">Date</th>
                                                                                <th>In Time</th>
                                                                                <th>Out Time</th>
                                                                                <th>Status</th>
                                                                                <th>Work Duration</th>
                                                                                <th>Overtime</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {employee.daily_data?.map((day, dayIndex) => {
                                                                                const status = day.attendance?.attendence_status || "-";
                                                                                let statusClass = "";
                                                                                if (status === "Present") statusClass = "status-present";
                                                                                if (status === "Absent") statusClass = "status-absent";
                                                                                if (status === "Leave") statusClass = "status-leave";

                                                                                return (
                                                                                    <tr key={`day-${dayIndex}`} className={dayIndex % 2 === 0 ? "even-row" : "odd-row"}>
                                                                                        <td className="text-left">{day.date || "-"}</td>
                                                                                        <td>{day.attendance?.in_time || "-"}</td>
                                                                                        <td>{day.attendance?.out_time || "-"}</td>
                                                                                        <td>
                                                                                            <span className={`status-badge ${statusClass}`}>
                                                                                                {status}
                                                                                            </span>
                                                                                        </td>
                                                                                        <td>{day.attendance?.work_duration || "-"}</td>
                                                                                        <td>{day.attendance?.overtime || "-"}</td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {/* Daily Attendance Table */}


                                                {/* Spacer between employees */}
                                                <tr className="employee-spacer">
                                                    <td colSpan="12"></td>
                                                </tr>
                                            </React.Fragment>
                                        )))}

                                        <tr>
                                            <td colSpan="12">
                                                <div style={{ display: 'flex' }}>
                                                    <label className='repo-heading font-weight500 font-size-heading'>Client Details</label>
                                                    <label onClick={() => setIsClientDetailsVisible(!isClientDetailsVisible)} style={{ marginLeft: 'auto', fontWeight: 600, color: '#2576bc', cursor: 'pointer', fontSize: '14px' }}>{isClientDetailsVisible ? 'Collapse' : 'Expand'}</label>
                                                </div>
                                            </td>
                                        </tr>
                                        {isClientDetailsVisible && <tr>
                                            <td colSpan="12">
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', boxSizing: 'border-box', padding: '8px 0px' }}>
                                                    {project.client_data?.map((client, index) => (
                                                        <div key={`${client.client_name}-${index}`} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-around', padding: '8px', borderRadius: '8px', boxSizing: 'border-box', backgroundColor: '#f4f7fe' }}>
                                                            <div style={{ display: 'flex', width: '22%', flexDirection: 'column', justifyContent: 'center', boxSizing: 'border-box', padding: '8px', backgroundColor: '#fff', borderRadius: '8px' }}>
                                                                <label style={{ fontSize: '14px', fontWeight: 500, color: '#707070' }}>Client Name</label>
                                                                <label>{client.client_name}</label>
                                                            </div>
                                                            <div style={{ display: 'flex', width: '22%', flexDirection: 'column', justifyContent: 'center', boxSizing: 'border-box', padding: '8px', backgroundColor: '#fff', borderRadius: '8px' }}>
                                                                <label style={{ fontSize: '14px', fontWeight: 500, color: '#707070' }}>Status</label>
                                                                <label>{client.status}</label>
                                                            </div>
                                                            <div style={{ display: 'flex', width: '22%', flexDirection: 'column', justifyContent: 'center', boxSizing: 'border-box', padding: '8px', backgroundColor: '#fff', borderRadius: '8px' }}>
                                                                <label style={{ fontSize: '14px', fontWeight: 500, color: '#707070' }}>Billed</label>
                                                                <label>{Number(client.total_billed).toLocaleString(undefined, { maximumFractionDigits: 0 })}</label>
                                                            </div>
                                                            <div style={{ display: 'flex', width: '22%', flexDirection: 'column', justifyContent: 'center', boxSizing: 'border-box', padding: '8px', backgroundColor: '#fff', borderRadius: '8px' }}>
                                                                <label style={{ fontSize: '14px', fontWeight: 500, color: '#707070' }}>Pending</label>
                                                                <label>{client.total_pending}</label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>}
                                        {/* Employee Data */}
                                        {/* <tr>
                                            <td colSpan="7">
                                                <h4>Employee Details</h4>
                                                {project.employee_data?.map((employee, empIndex) => (
                                                    <div key={`emp-${empIndex}`} style={{ marginBottom: "20px" }}>
                                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Employee Code</th>
                                                                    <th>Total Salary</th>
                                                                    <th>Attendance Days</th>
                                                                    <th>Present Days</th>
                                                                    <th>Absent Days</th>
                                                                    <th>Leave Days</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{employee.emp_code}</td>
                                                                    <td>{employee.total_salary}</td>
                                                                    <td>{employee.attendance_stats?.total_days}</td>
                                                                    <td>{employee.attendance_stats?.present_days}</td>
                                                                    <td>{employee.attendance_stats?.absent_days}</td>
                                                                    <td>{employee.attendance_stats?.leave_days}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                        <h5>Daily Attendance</h5>
                                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th>Date</th>
                                                                    <th>In Time</th>
                                                                    <th>Out Time</th>
                                                                    <th>Status</th>
                                                                    <th>Work Duration</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {employee.daily_data?.map((day, dayIndex) => (
                                                                    <tr key={`day-${dayIndex}`}>
                                                                        <td>{day.date}</td>
                                                                        <td>{day.attendance?.in_time || "-"}</td>
                                                                        <td>{day.attendance?.out_time || "-"}</td>
                                                                        <td>{day.attendance?.attendence_status || "-"}</td>
                                                                        <td>{day.attendance?.work_duration || "-"}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ))}
                                            </td>
                                        </tr> */}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>


                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div >
            </div >
        </>
    );
};

export { PnLSheet, ProfitAndLossSheet };
